import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '..';

export const selectFleetDashboardsData = (state: RootState) => state.fleetManagement.dashboards;
export const selectFleetDashboardsRestState = (state: RootState) =>
  state.fleetManagement.dashboards.rest;

export const selectFleetDataSetsData = (state: RootState) =>
  state.fleetManagement.datasets.data?.datasets;
export const selectFleetFieldsConfiguration = (state: RootState) =>
  state.fleetManagement.datasets.data?.fields;
export const selectFleetFiltersConfiguration = (state: RootState) =>
  state.fleetManagement.datasets.data?.filterSets;
export const selectFleetOperationsConfiguration = (state: RootState) =>
  state.fleetManagement.datasets.data?.operationSets;
export const selectFleetWidgetsConfiguration = (state: RootState) =>
  state.fleetManagement.datasets.data?.widgets;
export const selectFleetDataSetsRestState = (state: RootState) =>
  state.fleetManagement.datasets.rest;

export const selectCurrentDashboardId = (state: RootState) =>
  state.fleetManagement.dashboards.selectedId;
export const selectFleetData = (state: RootState) => state.fleetManagement.live;

export const selectCurrentDashboard = createSelector(
  [selectFleetDashboardsData, selectCurrentDashboardId],
  (dashboardsData, dashboardId) => {
    return dashboardsData.data?.find((d) => d.id === dashboardId);
  },
);

export const selectFleetLiveEntry = createSelector(
  [selectFleetData, (_state: RootState, id: string | null) => id],
  (live, id) => {
    return live.find((l) => l.id === id);
  },
);
